import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import ConsoleHrozontalHeadTable, { DataListProps } from "../-components/ConsolehorizontalHeadTable";
import LoadingPop from "components/popup/LoadingPop";
import FaqForm, { FaqFormProps } from "./FaqForm";
import { useGetConsoleFaqDetail } from "hooks/console/useGetConsoleFaqDetail";
import { useDeleteConsoleFaq } from "hooks/console/useDeleteConsoleFaq";
import PageHeader from "../-components/PageHeader";
import { RouteTypes, toastErrorSyle } from "hooks/utils/util";
import { enum_api_uri } from "hooks/utils/enum";
import speaker from "assets/common/support/notice_speaker.png";
import ConfirmDialog from "components/popup/ConfirmDialog";
import Seo from "components/Seo";

// 임시
const thead = [
    {
        title: "상단고정",
        key: "notice",
        content: (value: string) => <div>{value ? <img src={speaker} alt="" /> : "-"}</div>,
    },
    { title: "제목", key: "subject" },
    { title: "작성일", key: "w_date" },
    {
        title: "첨부파일",
        key: "b_file",
        content: (value: string) => {
            if (value) {
                return (
                    <div
                        className="hover:underline cursor-pointer"
                        onClick={() => {
                            const src = enum_api_uri.api_uri + "/upload/board/" + value;
                            window.open(src, "_blank", "noopener, noreferrer");
                        }}
                    >
                        {value}
                    </div>
                );
            }
            return <div>파일 없음</div>;
        },
    },
    {
        title: "내용",
        key: "contents",
        content: (value: string) => <div className="py-3" dangerouslySetInnerHTML={{ __html: value }} />,
    },
];

const initialForm = {
    category: "",
    name: "",
    subject: "",
    contents: "",
    notice: 0,
    b_file: "",
    list_no: null,
};

export default function ConsoleFaqDetail({ type }: { type: RouteTypes }) {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    const idx = params.idx;
    const page = location.state?.page ?? "1";
    const [editMode, setEditMode] = useState(false);
    const { data, isLoading } = useGetConsoleFaqDetail({ category: type, list_no: idx ?? "" });
    const { mutate: deleteFaq } = useDeleteConsoleFaq();
    const [form, setForm] = useState<FaqFormProps>(initialForm);

    useEffect(() => {
        if (data) {
            setForm(prev => ({
                ...prev,
                category: type,
                flag: data.flag,
                list_no: data.list_no,
                subject: data.subject || "",
                contents: data.contents || "",
                notice: data.notice,
                w_date: data.w_date,
                b_file: data.b_file,
            }));
        }
    }, [data]);

    const handleDeleteFaq = () => {
        deleteFaq(
            { category: type, list_no: [Number(idx)] },
            {
                onSuccess: () => {
                    toast.success("성공적으로 삭제 되었습니다.");
                    navigate(-1);
                },
                onError: (error: any) => {
                    const message = error.message;
                    toast.error(message, toastErrorSyle);
                },
            },
        );
    };

    if (!idx) return <div>잘못된 접근입니다.</div>;

    return (
        <>
            <Seo type="console" pageTitle="FAQ" />
            <div className="flex-1 flex flex-col overflow-hidden max-h-[100dvh]">
                <PageHeader category="사이트관리" title="FAQ상세" />
                <div className="flex-1 bg-[#F7F6FB] flex overflow-hidden">
                    <div className="px-[40px] py-[28px] w-full overflow-auto">
                        {data ? (
                            <div className="bg-white rounded-[20px] py-[36px] px-[40px] w-full min-w-[800px]">
                                {editMode ? (
                                    <>
                                        {isLoading ? (
                                            <LoadingPop />
                                        ) : (
                                            <FaqForm type={type} form={form} setForm={setForm} update setEditMode={setEditMode} />
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <ConsoleHrozontalHeadTable thead={thead} tbody={data} />
                                        <div className="flex justify-center gap-x-[8px] mt-5">
                                            <button
                                                className="text-[#666666] text-[18px] bg-white rounded-[5px] border border-[#dddddd] px-[55px] py-[15px]"
                                                onClick={() => setEditMode(true)}
                                            >
                                                수정
                                            </button>
                                            <ConfirmDialog
                                                title="FAQ 삭제"
                                                trigger={open => (
                                                    <button
                                                        type="button"
                                                        onClick={open}
                                                        className="text-[#666666] text-[18px] bg-white rounded-[5px] border border-[#dddddd] px-[55px] py-[15px]"
                                                    >
                                                        삭제
                                                    </button>
                                                )}
                                                handleConfirm={handleDeleteFaq}
                                            />
                                            <button
                                                onClick={() => (page ? navigate(`/${type}/manage/faq?page=${page}`) : navigate(-1))}
                                                className="text-white text-[18px] bg-[#4F46E5] rounded-[5px] border border-[#666666] px-[55px] py-[15px]"
                                            >
                                                목록
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        ) : (
                            <div className="bg-white rounded-[20px] flex flex-col gap-5 items-center justify-center py-[100px]">
                                <p>결과가 없습니다.</p>
                                <button onClick={() => navigate(-1)} className="rounded-[8px] border px-5 py-2">
                                    뒤로가기
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Toaster position="bottom-center" reverseOrder={false} />
        </>
    );
}
